import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiWorkGenerated from '../../Api/ApiWorkGenerated';
import ToastMsg from '../../Components/ToastMsg';
import { creators as WorkGeneratedActions } from '../../Reducers/Reporting/WorkGenerated';

export function* getWorkGeneratedQuery({ payload }) {
  try {
    const response = yield call(
      ApiWorkGenerated.getQuery,
      payload.selectedYears,
    );

    if (response.status === 200) {
      yield put(
        WorkGeneratedActions.workgeneratedSuccess({ queryData: response.data }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Work Generated Query',
            text: response.message,
          },
        },
      );
      yield put(WorkGeneratedActions.workgeneratedFailure(response.message));
    }
  } catch (e) {
    yield put(WorkGeneratedActions.workgeneratedFailure(e));
  }
}
